import { DrawerContainer } from '../../Organismos/components/DrawerContainer';
import { useAppSelector } from '../../../hooks/reduxHooks';
import GenerateFilesSRTDrawer from './GenerateFilesSRTDrawer';
import UploadResponseSRTDrawer from './UploadResponseSRTDrawer';

export const DRAWER_ACTION_VALUES = {
    UPLOAD_RESPONSE_SRT: 'upload-response-srt',
    GENERATE_FILES_SRT: 'generate-files-srt'
};

const DrawerManager = ({ open, setOpen, translate, generateAndDownloadFiles, selectedPresentations, handleCloseDrawer }: any) => {
    const currentTab = useAppSelector((state) => state.srtPresentations.currentTab);

    const DrawerInputManager = () => {
        switch (open) {
            case DRAWER_ACTION_VALUES.GENERATE_FILES_SRT:
                return (
                    <GenerateFilesSRTDrawer
                        translate={translate}
                        handleCloseDrawer={handleCloseDrawer}
                        onSubmit={generateAndDownloadFiles}
                        selectedPresentations={selectedPresentations}
                        currentTab={currentTab}
                    />
                );
            case DRAWER_ACTION_VALUES.UPLOAD_RESPONSE_SRT:
                return (
                    <UploadResponseSRTDrawer
                        translate={translate}
                        handleCloseDrawer={handleCloseDrawer}
                        currentTab={currentTab}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={760}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;
